import { API_URL } from "../service.config";
import info from "../../utils/info";

export default {
  getUsers() {
    return API_URL.get(`/user`, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`
      }
    });
  },
  createUser(user: any) {
    return API_URL.post(`/user/sign-up`, user, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`
      }
    });
  },
  updateUser(user: any) {
    return API_URL.put(`/user`, user, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`
      }
    });
  },
  deleteUser(userID: any) {
    return API_URL.delete(`/user/${userID}`, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`
      }
    });
  }
};
